import {TOption} from './TOption'

export const PRODUCT_TYPE: TOption[] = [
  {value: 'P01', label: 'UREA'},
  {value: 'P02', label: 'NPK'},
  {value: 'P13', label: 'AMMONIA'},
  {value: '8105', label: 'KANTONG/SACK'},
  {value: 'P99', label: 'Product Lainnya'},
]
